module.exports = __webpack_public_path__ + "static/media/shaving_kit.acc1867f.svg";